<template>
  <!-- Hero Section -->
  <section class="hero_sec t-center big_container" :style="marginTopBottom">
    <!-- eslint-disable-next-line vue/no-v-text-v-html-on-component -->
    <component
      :is="shopifyData.headingTag"
      :class="headingVisible ? 'main_heading heroheading_top' : 'is-hidden-heading'"
    >
      {{ shopifyData.heading }}
    </component>

    <Transition name="nested" appear>
      <a :href="shopifyData.imagelink" class="outer" aria-label="Hero Banner Image Link">
        <!-- Desktop Image -->
        <img
          :src="shopifyData.heroImage.imgSrc"
          loading="lazy"
          aria-label="Hero Banner Image"
          width="auto"
          height="auto"
          :class="[shopifyData.imageWidth == '' ? '' : 'hero_img_width', 'hero_img']"
          class="heroDesktopImg inner fade-in"
          :style="{ 'max-width': shopifyData.imageWidth }"
          :alt="shopifyData.heroImage.alt || 'Hero Banner Image'"
          :fetchpriority="shopifyData.isHero ? 'high' : 'low'"
          :decoding="shopifyData.isHero ? 'sync' : 'async'"
        />

        <!-- Mobile Image -->
        <img
          :src="shopifyData.heroImageMobile.imgSrc"
          :class="[shopifyData.imageWidthMobile == '' ? '' : 'hero_img_width', 'hero_img']"
          loading="lazy"
          aria-label="Hero Banner Mobile Image"
          width="auto"
          height="auto"
          class="heroMobileImg inner fade-in"
          :style="{ 'max-width': shopifyData.imageWidthMobile }"
          :alt="shopifyData.heroImageMobile.alt || 'Hero Banner Mobile Image'"
          :fetchpriority="shopifyData.isHero ? 'high' : 'low'"
          :decoding="shopifyData.isHero ? 'sync' : 'async'"
        />
      </a>
    </Transition>

    <component :is="shopifyData.subHeadingTag" class="main_heading heroheading_bottom">
      {{ shopifyData.subHeading }}
    </component>
  </section>
</template>
<script>
export default {
  props: {
    shopifyData: {
      type: Object,
      required: true,
    },
  },
  data: () => {
    // Hero Heading Animation
    window.addEventListener('scroll', () => {
      const heroSec = document.querySelector('.hero_sec');
      const mainHeading = document.querySelectorAll('.hero_sec .main_heading');
      const heroSecHeight = heroSec.getBoundingClientRect().height;

      const halfHeight = heroSecHeight / 1.2;

      if (window.scrollY <= halfHeight) {
        for (const i of mainHeading) {
          i.setAttribute(
            'style',
            `opacity:${1 - (window.scrollY / halfHeight).toFixed(1)}; transition:0.4s;`
          );
        }
      }
    });
  },
  computed: {
    headingVisible() {
      return this.shopifyData.headingVisiblity === 'true';
    },
    marginTopBottom() {
      return {
        'padding-top':
          window.innerWidth > 768
            ? `${this.shopifyData.deskMarginTop}px`
            : `${this.shopifyData.mobMarginTop}px`,
        'padding-bottom':
          window.innerWidth > 768
            ? `${this.shopifyData.deskMarginBottom}px`
            : `${this.shopifyData.mobMarginBottom}px`,
      };
    },
  },
  mounted() {},
};
</script>

<style scoped>
/* index Hero sec */

/* rules that target nested elements */
.nested-enter-active .inner,
.nested-leave-active .inner {
  transition: all 0.5s ease-in-out;
}

.nested-enter-from .inner,
.nested-leave-to .inner {
  transform: translateY(-20px);
  opacity: 0;
}
.hero_sec {
  padding: 50px 0px 100px;
}
.hero_sec .is-hidden-heading {
  opacity: 0 !important;
  z-index: -1;
  visibility: hidden;
  position: fixed;
}
.hero_img {
  margin: 0 auto;
  display: block;
}

.hero_img_width {
  width: 100%;
}

.heroMobileImg {
  display: none;
}

.heroheading_top {
  transform: translateY(40%);
}

.heroheading_bottom {
  transform: translateY(-45%);
}

.main_heading {
  line-height: 62px;
}

.heroDesktopImg {
  height: auto;
}

@media only screen and (max-width: 767px) {
  .hero_sec {
    padding: 50px 0px 30px;
  }

  .heroDesktopImg {
    display: none;
  }

  .heroMobileImg {
    display: block;
  }

  .heroheading_bottom {
    transform: translateY(-35%);
  }

  .main_heading.heroheading_top {
    line-height: 39px;
  }

  .main_heading.heroheading_bottom {
    line-height: 43px;
  }
}
</style>
